import Glide from '@glidejs/glide';

const timelineSliderOptions = {
  type: 'carousel',
  startAt: 0,
  perView: 1,
  autoplay: 5000,
  animationDuration: 1000,
};

const contentSliderOptions = {
  type: 'carousel',
  startAt: 0,
  perView: 1,
  autoplay: 5000,
  animationDuration: 1000,
};

const eventSliderOptions = {
  type: 'carousel',
  startAt: 0,
  perView: 1,
  autoplay: 5000,
  animationDuration: 1000,
};

const headerSliderOptions = {
  type: 'carousel',
  startAt: 0,
  perView: 1,
  autoplay: 4500,
  gap: 0,
  rewindDuration: 0,
  animationDuration: 0,
  hoverpause: false,
  keyboard: false,
  swipeThreshold: false,
  dragThreshold: false,
};

export function initSliders() {
  const paintingsSlider = document.querySelector('.paintings-slider');
  if (paintingsSlider) {
    new Glide(paintingsSlider, {
      type: 'carousel',
      startAt: 0,
      perView: 1,
      gap: 30,
      autoplay: 3000,
      animationDuration: 1000,
    }).mount();
  }

  document.querySelectorAll('.timeline-slider').forEach((slider) => {
    new Glide(slider, timelineSliderOptions).mount();
  });

  document.querySelectorAll('.content-slider').forEach((slider) => {
    new Glide(slider, contentSliderOptions).mount();
  });

  document.querySelectorAll('.event-slider').forEach((slider) => {
    new Glide(slider, eventSliderOptions).mount();
  });

  document.querySelectorAll('.header-slider').forEach((slider) => {
    const glide = new Glide(slider, headerSliderOptions);
    glide.on('run.after', function () {
      const otherSlides = slider.querySelectorAll('.glide__slide:not(.glide__slide--active) img');
      for (const slide of otherSlides) {
        setTimeout(() => {
          // Reset der CSS-Animation auf den anderen Slides
          slide.style.animation = 'none';
          // Force-Reflow, damit der Browser die animation:none-Änderung anwendet,
          // bevor animation:'' zurückgesetzt wird. Ohne dieses Property-Read
          // würde der Browser die zwei Zuweisungen zusammenfassen.
          void slide.offsetHeight;
          slide.style.animation = '';
        }, 2500);
      }
    });
    glide.mount();
  });
}
